import React from "react";
import { useNavigate } from "react-router-dom";

const OptionsButton = ({ ...props }) => {
	const navigate = useNavigate();
	return (
		<div className="h-3 flex items-center" {...props}>
			<img
				className="h-full mr-4 w-auto object-contain"
				src={require("../../images/optionButton.png")}
				alt="option-button"
			/>
		</div>
	);
};

export default OptionsButton;
